import {
    PagesContainer,
    StyledPageSelector,
    StyledPageSelectorText,
    StyledPageSelectorWrapper
} from "./PageSelector.styles";
import React from "react";

const PageSelector = ({numberOfPages, page, setPage}) => {

    const renderPages = () => {
        let view = [];

        for (let i = 0; i < numberOfPages; i++) {
            view.push(
                <StyledPageSelector key={i} active={page === (i+1)} onClick={() => setPage(i+1)}>
                    {i+1}
                </StyledPageSelector>
            );
        }

        return view;
    };

    return (<StyledPageSelectorWrapper>
        <StyledPageSelectorText>{'Strona'}</StyledPageSelectorText>
        <PagesContainer>{renderPages()}</PagesContainer>
    </StyledPageSelectorWrapper>)
};

export default PageSelector;
